// firebase/app-auth.js — Initialisation légère : App + Auth UNIQUEMENT (sans Firestore)
// Importé par UserRoleContext au démarrage → ne charge PAS @firebase/firestore
import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  initializeAuth, getAuth,
  indexedDBLocalPersistence, browserLocalPersistence,
  browserPopupRedirectResolver,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

let _auth;
try {
  _auth = initializeAuth(app, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    popupRedirectResolver: browserPopupRedirectResolver,
  });
} catch {
  _auth = getAuth(app);
}
_auth.useDeviceLanguage?.();

export { _auth as auth };
export { getAuth };
